import React, { Component } from 'react';
import { Modal, Button } from 'react-bootstrap';
import AdServerContainer from 'containers/AdServerContainer';
import { AdServer } from 'models/interfaces';
import gql from 'graphql-tag';
import { Mutation, Query } from 'react-apollo';

const ADSERVER_SAVE_QUERY = gql`
  mutation doThomasAdServer($name: String!, $description: String) {
    saveAdServer(name: $name, description: $description) {
      # ad_server_id
      # name
      description
    }
  }
`;

const ADSERVER_UPDATE_QUERY = gql`
  mutation doThomasAdServer($ad_server_id: ID!, $name: String!, $description: String) {
    updateAdServer(ad_server_id: $ad_server_id, name: $name, description: $description) {
      # ad_server_id
      # name
      description
    }
  }
`;

interface IState {
  showResults: boolean;
  showModal: boolean;
  ad_server_id: number;
  name: string;
  description?: string;
}
class AddServerPage extends Component<any, IState> {
  constructor(props: any) {
    super(props);
    this.state = {
      showResults: true,
      showModal: false,
      ad_server_id: 0,
      name: '',
      description: ''
    };
  }
  preModalAction = (ad: AdServer) => {
    console.log('preModalAction fired');
    console.log(ad);
    this.setState({
      showModal: true,
      name: ad.name,
      description: ad.description,
      ad_server_id: ad.ad_server_id
    });
    console.log(this.state.name);
  };
  modalClose = () => {
    console.log('close modal');
    this.setState({ showResults: false });

    this.setState({ showResults: true, showModal: false });
  };
  onErrorAlert = () => {
    console.log('error alert');
  };

  componentDidMount() {}
  render() {
    return (
      <section>
        <h1 className="page-title">
          AdServers{' '}
          <span className="header-title-btn">
            <button
              className="btn btn-primary"
              onClick={() => this.preModalAction({ ad_server_id: 0, name: '', description: '' })}
            >
              Add
            </button>
          </span>
        </h1>

        <section className="card">
          {this.state.showResults && (
            <AdServerContainer>
              {({ data }) => (
                <section>
                  <table className="table hover blueprint-table table-wrap">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Description</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data &&
                        data.adServers &&
                        data.adServers.map((x: AdServer, i) => (
                          <tr key={x.ad_server_id}>
                            <td>{x.name}</td>
                            <td>{x.description}</td>
                            <td>
                              <Button
                                variant="primary"
                                onClick={() =>
                                  this.preModalAction({
                                    name: x.name,
                                    ad_server_id: x.ad_server_id,
                                    description: x.description
                                  })
                                }
                              >
                                Edit
                              </Button>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </section>
              )}
            </AdServerContainer>
          )}
        </section>

        <Modal
          show={this.state.showModal}
          onHide={this.modalClose}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              {this.state.ad_server_id == 0 ? ' New AdServer' : 'Edit'}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <input type="hidden" value={this.state.ad_server_id} />
            <div className="row">
              <div className="saturn-form-group col-md-4">
                <label>Name:</label>
                <input
                  type="text"
                  value={this.state.name}
                  onChange={e => {
                    this.setState({ name: e.target.value });
                  }}
                  className="form-control"
                />
              </div>
            </div>
            <div className="row">
              <div className="saturn-form-group col-md-4">
                <label>description:</label>
                <input
                  type="text"
                  value={this.state.description ? this.state.description : ''}
                  onChange={e => {
                    this.setState({ description: e.target.value });
                  }}
                  className="form-control"
                />
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button className="btn btn-danger" onClick={this.modalClose}>
              Close
            </Button>{' '}
            <Mutation
              mutation={this.state.ad_server_id == 0 ? ADSERVER_SAVE_QUERY : ADSERVER_UPDATE_QUERY}
              onError={this.onErrorAlert}
              onCompleted={this.modalClose}
            >
              {(doThomasAdServer: (arg0: { variables: { name: string; description: string | undefined; ad_server_id?: undefined; } | { ad_server_id: number; name: string; description: string | undefined; }; }) => void, { loading, error }: any) => (
                <div>
                  <button
                    className="btn btn-primary"
                    onClick={() =>
                      doThomasAdServer({
                        variables:
                          this.state.ad_server_id == 0
                            ? { name: this.state.name, description: this.state.description }
                            : {
                                ad_server_id: this.state.ad_server_id,
                                name: this.state.name,
                                description: this.state.description
                              }
                      })
                    }
                  >
                    save
                  </button>
                </div>
              )}
            </Mutation>
          </Modal.Footer>
        </Modal>
      </section>
    );
  }
}

export default AddServerPage;
